import React from 'react';
import PAWN_TICKET_TYPE from './pawnTicketType';

const NAVY = '#1a2744';
const GOLD = '#c5a059';

/** "GR FINANCIERS" → "G R FINANCIERS" so short initials match the pawn-ticket header. */
export function formatTicketCompanyName(name) {
  const raw = String(name || 'COMPANY NAME').trim().toUpperCase().replace(/\s+/g, ' ');
  const parts = raw.split(' ');
  const head = (parts[0] || '').replace(/\./g, '');
  if (parts.length >= 2 && head.length >= 2 && head.length <= 4) {
    return `${head.split('').join(' ')} ${parts.slice(1).join(' ')}`;
  }
  return raw;
}

export default function TicketCompanyTitle({ name }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 7,
        flexWrap: 'nowrap',
        width: 'auto',
        marginRight: 'auto',
      }}
    >
      <span style={{ width: 22, height: 1.5, background: GOLD, flex: '0 0 22px' }} />
      <div
        style={{
          fontFamily: '"Times New Roman", Times, serif',
          fontSize: PAWN_TICKET_TYPE.companyName.fontSize,
          fontWeight: PAWN_TICKET_TYPE.companyName.fontWeight,
          letterSpacing: '0.04em',
          lineHeight: 1,
          color: NAVY,
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
        }}
      >
        {formatTicketCompanyName(name)}
      </div>
      <span style={{ width: 22, height: 1.5, background: GOLD, flex: '0 0 22px' }} />
    </div>
  );
}
